import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBoostComponent } from './simple-icons-boost.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBoostComponent ],
    exports:      [ SimpleIconsBoostComponent ],
    bootstrap:    []
})
export class SimpleIconsBoostModule {}
